import { CircleUser } from "@/icons/CircleUser.tsx";
import { FileInvoiceDollar } from "@/icons/FileInvoiceDollar.tsx";
import useUserStore from "@/store/user.store.ts";
import { memo, useMemo } from "react";
import { CreditCard } from "@/icons/CreditCard.tsx";
import { RightFromBracket } from "@/icons/RightFromBracket.tsx";
import { Avatar, Menu, UnstyledButton } from "@mantine/core";
import { Link } from "react-router";

export const UserMenu = memo(function UserMenu() {
  const { logout, user, isAdmin } = useUserStore();

  const webUrl = import.meta.env.VITE_WEB_URL;

  if (!user) {
    return null;
  }

  return useMemo(
    () => (
      <Menu
        width={260}
        position="bottom-end"
        transitionProps={{ transition: "pop-top-right" }}
        withinPortal
        withArrow
        arrowPosition="center"
      >
        <Menu.Target>
          <UnstyledButton>
            <Avatar src={user?.avatar} alt={user?.name} radius="md" size={34}>
              <CircleUser size={28} />
            </Avatar>
          </UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Label>Settings</Menu.Label>
          <Menu.Item
            component={Link}
            to="/billing"
            leftSection={<CreditCard />}
          >
            Billing
          </Menu.Item>
          <Menu.Item
            component="a"
            href={`${webUrl}/portal/${user.uuid}`}
            leftSection={<FileInvoiceDollar />}
          >
            Invoices
          </Menu.Item>

          <Menu.Divider />

          {isAdmin && (
            <>
              <Menu.Label>Admin area</Menu.Label>
              <Menu.Item
                component={Link}
                to="/admin"
                leftSection={<CircleUser />}
              >
                Users
              </Menu.Item>
              <Menu.Divider />
            </>
          )}

          <Menu.Item onClick={logout} leftSection={<RightFromBracket />}>
            Logout
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    ),
    [user, logout],
  );
});
